import React, { Component } from 'react';
import './App.css';
import ContentManager from './ContentManager';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import reducer from './reducer';
import { composeWithDevTools } from 'redux-devtools-extension';
import ModalManager from './ModalManager';

const store = createStore(reducer, {}, composeWithDevTools());

class App extends Component {
  render() {
    return (
        <Provider store={store}>
          <Router>
            <div className="App">

              <div className="Content-wrapper">
                <div className="Content-container">

                  <ModalManager/>

                  <ContentManager/>

                </div>
              </div>
            </div>
          </Router>
        </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js